import EditQuoteTagDialog from './EditQuoteTagDialog'

export * from './EditQuoteTagDialog'
export default EditQuoteTagDialog
